import * as React from 'react';
import { SVGProps } from 'react';

const IconCrownSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 13h12v2H2zm12-2H2L1 4l4 3 3-6 3 6 4-3-1 7z" />
  </svg>
);
export default IconCrownSizeS;
